import { useState } from "react";
import { useDashboard } from "context/DashboardContext";
import {
  DataTable,
  Field,
  LoadState,
  Page,
  Panel,
  dateTime,
  money,
} from "layouts/finance/shared";

export default function Ledger() {
  const { ledgerData, ledgerLoading, ledgerError, getLedger } = useDashboard();
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [query, setQuery] = useState("");
  const rows = ledgerData.filter((row) =>
    `${row.balance_id} ${row.meta_data?.merchant_name || ""} ${
      row.meta_data?.balance_type || ""
    }`
      .toLowerCase()
      .includes(query.toLowerCase())
  );
  const activePage = Math.min(
    page,
    Math.max(0, Math.ceil(rows.length / size) - 1)
  );
  return (
    <Page
      title="Admin ledger"
      description="Merchant balances, debits, and credits from the existing ledger."
      actions={
        <button className="fin-button secondary" onClick={getLedger}>
          Refresh ledger
        </button>
      }
    >
      <Panel>
        <div className="toolbar">
          <Field
            label="Search balance or merchant"
            value={query}
            onChange={(e) => {
              setQuery(e.target.value);
              setPage(0);
            }}
          />
          <Field
            label="Items per page"
            value={size}
            options={["10", "20", "50", "70", "100"]}
            onChange={(e) => {
              setSize(Number(e.target.value));
              setPage(0);
            }}
          />
        </div>
      </Panel>
      <LoadState
        loading={ledgerLoading}
        error={ledgerError}
        refresh={getLedger}
      />
      {!ledgerLoading && !ledgerError && (
        <Panel title="Ledger balances">
          <DataTable
            rowKey="balance_id"
            rows={rows.slice(activePage * size, activePage * size + size)}
            columns={[
              {
                key: "created_at",
                label: "Date",
                render: (row) => dateTime(row.created_at),
              },
              { key: "balance_id", label: "Balance ID" },
              { key: "currency", label: "Currency" },
              ...[
                ["debit_balance", "Debit"],
                ["credit_balance", "Credit"],
                ["balance", "Balance"],
              ].map(([key, label]) => ({
                key,
                label,
                render: (row) =>
                  row[key] == null ? "—" : money(row[key] / 100),
              })),
              {
                key: "balance_type",
                label: "Balance type",
                render: (row) => row.meta_data?.balance_type ?? "—",
              },
              {
                key: "merchant_name",
                label: "Merchant",
                render: (row) => row.meta_data?.merchant_name ?? "—",
              },
              { key: "indicator", label: "Indicator" },
            ]}
          />
          <div className="pagination">
            <span>
              {rows.length} balances · Page {activePage + 1}
            </span>
            <button
              className="fin-button secondary"
              disabled={activePage === 0}
              onClick={() => setPage(activePage - 1)}
            >
              Previous
            </button>
            <button
              className="fin-button secondary"
              disabled={(activePage + 1) * size >= rows.length}
              onClick={() => setPage(activePage + 1)}
            >
              Next
            </button>
          </div>
        </Panel>
      )}
    </Page>
  );
}
